import React, { useEffect } from "react";
import sampleImage from "../../assets/services/image 65.png";
import fssaiLogo from "../../assets/services/fssai.png";
import Form from "./Form";
// import PackageCard from './PackageCard';
import OtherServices from "./OtherServices";
import AOS from "aos";
import "aos/dist/aos.css";

const FormSide = ({ service }) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  console.log("logoofservice", service?.logo_url)

  return (
    <div className=" w-full space-y-6">
      <Form />

      {/* <img
        data-aos="flip-right"
        src={sampleImage}
        alt="help-img"
        className="w-full h-auto rounded-md"
      /> */}

      {/* <PackageCard />
            <PackageCard /> */}

      {/* <img
        data-aos="flip-left"
        src={service?.logo_url}
        alt="help-img"
        className="w-full h-auto rounded-md"
      /> */}

      {/* <OtherServices /> */}
    </div>
  );
};

export default FormSide;
